import { useFormSchema } from "src/api/hooks/useFormSchema";

export const DateTimeWidget = (props: any) => {
  const { value, onChange, label, required, id, uiSchema } = props;
  const dateTimeValue = value ? new Date(value).toISOString().slice(0, 16) : "";
  const { data: schema } = useFormSchema();
  const primaryColor = schema?.theme?.colors?.primary;

  return (
    <div className={`datetime-container container`}>
      <input
        name={label}
        id={`${id}-datetime`}
        type="datetime-local"
        className={`input-datetime`}
        value={dateTimeValue}
        onChange={(e) => onChange(e.target.value || undefined)}
        required={required}
      />
    </div>
  );
};
